import { render, staticRenderFns } from "./FilterCollectionsSchemes.vue?vue&type=template&id=17551510&"
import script from "./FilterCollectionsSchemes.vue?vue&type=script&lang=js&"
export * from "./FilterCollectionsSchemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports